import { render, staticRenderFns } from "./DetailCollectionPlace.vue?vue&type=template&id=73f99caf&"
import script from "./DetailCollectionPlace.vue?vue&type=script&lang=js&"
export * from "./DetailCollectionPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports